import LinkAttachments from 'app/components/LinkAttachments';
import React, { FC } from 'react';
import { PostComposerFormState } from 'app/modules/posts/modules/post/components/composer/utils/postComposerFormState';
import { Field } from '@kontentino/ui';
import { PostComposerFormOptions } from 'app/modules/posts/modules/post/components/composer/hooks/usePostComposerFormOptions';
import { UseSetStateAction } from 'utils/hooks/useSetState';
import UserPermissionGate from 'components/UserPermissionGate';
import { UserPermission } from 'constants/userPermission';

type Props = {
  value: PostComposerFormState;
  onChange: UseSetStateAction<PostComposerFormState>;
  onOptionsChange: UseSetStateAction<PostComposerFormOptions>;
  maxCount?: number;
  withLinkOwnership?: boolean;
  withMultiShareEndCard?: boolean;
  withDescriptionField?: boolean;
  withCallToAction?: boolean;
  isFullLinkEditable?: boolean;
};

const PostComposerContentLinkAttachments: FC<Props> = ({
  value,
  onChange,
  maxCount,
  onOptionsChange,
  withMultiShareEndCard,
  withLinkOwnership,
  withDescriptionField,
  withCallToAction,
  isFullLinkEditable,
}) => {
  return (
    <UserPermissionGate scopes={UserPermission.POST_EDIT_ASSETS}>
      <Field.Group>
        <Field.Label required>Link</Field.Label>
        <LinkAttachments
          isFullLinkEditable={isFullLinkEditable}
          maxCount={maxCount}
          dataNamePrefix="posts-composer"
          page={value.page}
          attachments={value.attachments}
          onAttachmentsChange={(updater) =>
            onChange((prev) => ({
              attachments: {
                ...prev.attachments,
                ...updater(prev.attachments),
              },
            }))
          }
          onOptionsChange={onOptionsChange}
          withLinkOwnership={withLinkOwnership}
          withMultiShareEndCard={withMultiShareEndCard}
          withDescriptionField={withDescriptionField}
          withCallToAction={withCallToAction}
        />
      </Field.Group>
    </UserPermissionGate>
  );
};

export default PostComposerContentLinkAttachments;
